import React, { useEffect, useState } from "react";
import { DateTime } from "luxon";
import {
  amountFormatter,
  useCountdownV2,
  updateAuctionEventStatus_AuctionFloor,
  sendEventAnnouncement_AuctionFloor,
  getAuctionEventStatusById_AuctionFloor,
} from "services";
import ConfettiIconColor from "../../icons/ConfettiIconColor";
import SimpleHammerIcon from "../../icons/SimpleHammerIcon";
import { Button } from "../../shadcn/components/ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../../shadcn/components/ui/dialog";
import { Input } from "../../shadcn/components/ui/input";
import EventContentData from "../bidder/Tabs/auctionFloor/components/EventContentData";
import PropertyContentData from "../bidder/Tabs/auctionFloor/components/PropertyContentData";
import BidHistoryModel from "../bidder/Tabs/auctionFloor/components/BidHistoryModel";
import { Textarea } from "../../shadcn/components/ui/textarea";
import BidHistorySection from "../bidder/Tabs/auctionFloor/components/BidHistorySection";
import TimerProgressBar from "./TimerProgressBar";
import { useRouter } from "next/router";
import CheckIcon from "../../icons/CheckIcon";
import Dot from "../../icons/Dot";

export default function BankerEventDataV2(props: any) {
  const {
    data,
    endTime,
    status,
    setStatus,
    latestBid,
    latestBidAmount,
    correctBids,
    wrongBids,
  } = props;
  const {
    query: { id },
  } = useRouter();

  const [timeOffset, setTimeOffset] = useState(0);
  const [currentTime, setCurrentTime] = useState<any>(0);
  const [message, setMessage] = useState("");
  const [announcementSuccess, setAnnouncementSuccess] = useState(false);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentTime(
        DateTime.now()
          .plus({ milliseconds: timeOffset })
          .setZone("Asia/Kolkata")
          .toFormat("DDD hh:mm:ss a"),
      );
    }, 1000);
    return () => clearInterval(intervalId);
  }, [timeOffset]);

  const [hours, minutes, seconds, isTimeEnded] = useCountdownV2(
    endTime,
    timeOffset,
  );
  const [cancellationReason, setCancellationReason] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [showBidHistoryModel, setShowBidHistoryModel] =
    useState<boolean>(false);

  const handleCancelEvent = async (eventId: string) => {
    console.log("cancel reason", cancellationReason);
    try {
      const cancelEventResponse = await updateAuctionEventStatus_AuctionFloor(
        eventId,
        "cancelled",
        cancellationReason.trim(),
      );

      console.log("cancelEventResponse", cancelEventResponse);
      setCancellationReason("");
      window.location.reload();
    } catch (err) {
      console.log("error", err);
    }
  };

  const handleAnnouncement = async () => {
    try {
      const payload = {
        event_uuid: id,
        announcement: message.trim(),
        type: "announcement",
      };
      const announcementResponse = await sendEventAnnouncement_AuctionFloor(
        payload,
      );

      console.log("announcementResponse", announcementResponse);

      if (announcementResponse) {
        setAnnouncementSuccess(true);
      }
    } catch (err) {
      console.log("error", err);
    }
  };

  const AnnouncementSuccessModal = () => {
    return (
      <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-30">
        <div className="bg-white shadow-2xl rounded-xl w-full max-w-lg">
          <div className="w-full flex flex-col items-center px-4 py-6 border bg-[#FCFFFB] border-brand-bgGrey rounded-lg">
            <CheckIcon className="h-7 w-7 text-brand-bgSuccessGreen" />
            <div className="flex items-center space-x-3">
              <div>
                <p className="font-openSans text-center text-[22px] font-semibold text-brand-bgBlack">
                  {`Announcement  sent to the bidders`}
                </p>
                <p className="font-openSans text-center text-[16px] text-gray-700">
                  {message?.trim()}
                </p>
              </div>
            </div>

            <div className="w-full mt-8">
              <Button
                className="bg-brand-bgBlack text-white px-6 py-2 rounded-lg hover:bg-brand-bgBlack w-full"
                onClick={() => {
                  setMessage("");
                  setAnnouncementSuccess(false);
                }}
              >
                Close
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const checkBidStatus = async (checkStatus = 0) => {
    console.log("isTimeEnded inside checkBidStatus", isTimeEnded, checkStatus);
    if (isTimeEnded || checkStatus) {
      try {
        setTimeout(async () => {
          const res: any = await getAuctionEventStatusById_AuctionFloor(id);
          if (res?.status && res?.status === "end") {
            console.log("status came as end", res?.status);
            setStatus(res?.status);
          }
        }, 1000);
      } catch (error) {
        console.log("error", error);
      }
    }
  };

  useEffect(() => {
    console.log("isTimeEnded::>", isTimeEnded);
    (async () => {
      await checkBidStatus(isTimeEnded);
    })();
  }, [isTimeEnded]);

  return (
    <>
      <div className="flex items-center justify-between pb-5">
        <h1 className="text-lg font-openSans font-normal">
          {status === "end"
            ? "Auction has ended"
            : status === "cancelled"
            ? "Auction has been cancelled"
            : "Live Auction"}
        </h1>

        <div className={"invisible"}>
          <Dialog open={openModal} onOpenChange={setOpenModal}>
            <DialogTrigger asChild>
              {status !== "end" && (
                <Button
                  disabled={status === "cancelled"}
                  variant="outline"
                  className={`text-xs px-6 w-[125px] rounded-[12px] font-semibold ${
                    status === "cancelled"
                      ? "bg-red-300 text-white"
                      : "bg-white text-red-700 border-red-700"
                  }  hover:bg-red-700 hover:text-white`}
                >
                  {status === "cancelled" ? "Event Cancelled" : "Cancel Event"}
                </Button>
              )}
            </DialogTrigger>
            <DialogContent className="sm:max-w-md ">
              <DialogHeader>
                <DialogTitle>Cancel Event</DialogTitle>
                <DialogDescription>
                  Are you sure you want to cancel this event? Please confirm
                  your decision before proceeding
                </DialogDescription>
              </DialogHeader>
              <div className="flex items-center space-x-2 mt-4">
                <Textarea
                  placeholder="Reason for cancelling the event"
                  value={cancellationReason}
                  onChange={(e) => setCancellationReason(e.target.value)}
                />
              </div>
              <DialogFooter className="flex flex-col   sm:flex-row sm:justify-start">
                <Button
                  className="bg-black text-white hover:bg-gray-600"
                  variant="secondary"
                  onClick={() => {
                    if (id) handleCancelEvent(id.toString());
                  }}
                >
                  Send
                </Button>
                <DialogClose asChild>
                  <Button
                    className=" mt-2 sm:mt-0"
                    type="button"
                    variant="secondary"
                  >
                    Close
                  </Button>
                </DialogClose>
              </DialogFooter>
            </DialogContent>
          </Dialog>
        </div>
      </div>
      <div className="flex flex-col lg:flex-row gap-2 lg:gap-5">
        <div className="w-full lg:w-3/4 lg:p-8 lg:border border-gray-200">
          <div className="flex flex-col gap-4">
            <div className="">
              <div className="flex justify-between mb-3">
                <h3 className="text-[#262626] font-openSans text-sm lg:text-base capitalize pb-1">
                  Last Bidding
                </h3>
                <div className="bg-white py-1 px-3 border-[0.5px] rounded-full border-brand-textLightGrey flex items-center">
                  <Dot />
                  <span className="text-[10px] font-sans pl-3 font-normal text-brand-textBlack tracking-widest">
                    ID {data?.listing_id}
                  </span>
                </div>
              </div>
              <div className="flex gap-2 justify-between">
                <p className="mt-1 max-w-2xl text-sm text-brand-textGrey flex flex-col mid:flex-row gap-2">
                  <span className="text-[26px] font-semibold text-brand-orange">
                    {latestBid ? `₹ ${amountFormatter(latestBidAmount)}` : "NA"}
                  </span>
                  <span className="text-xs sm:text-sm">
                    at{" "}
                    {status !== "end"
                      ? `${currentTime} (IST)`
                      : latestBid?.bid_timestamp &&
                        `${DateTime.fromMillis(
                          typeof endTime === "string"
                            ? parseInt(endTime)
                            : endTime,
                        )
                          .setZone("Asia/Kolkata")
                          .toFormat("DD hh:mm:ss a")} (IST)`}
                  </span>
                </p>
                <div className="flex justify-between items-center">
                  <div className="flex flex-col justify-center items-center">
                    <div className="w-[124px] lg:w-[135px]">
                      <TimerProgressBar
                        startTime={DateTime.fromISO(data.start_date_time)
                          .setZone("Asia/Kolkata")
                          .toMillis()}
                        endTime={parseInt(data.final_end_date)}
                        currentTime={currentTime}
                      />
                      <div className="flex items-center justify-between gap-2 mt-1 lg:mt-2">
                        <div className="text-xs lg:text-sm">Time left</div>
                        <div
                          className={
                            "text-sm sm:col-span-2 " +
                            `${
                              status === "live" &&
                              endTime &&
                              endTime -
                                DateTime.now()
                                  .setZone("Asia/Kolkata")
                                  .toMillis() <=
                                parseInt(data?.extend_time_at) * 60 * 1000
                                ? "text-red-600 font-semibold"
                                : "text-gray-900 font-medium"
                            }`
                          }
                        >
                          {status === "live"
                            ? hours < 10
                              ? `0${hours}`
                              : hours
                            : "00"}
                          :
                          {status === "live"
                            ? minutes < 10
                              ? `0${minutes}`
                              : minutes
                            : "00"}
                          :
                          {status === "live"
                            ? seconds < 10
                              ? `0${seconds}`
                              : seconds
                            : "00"}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {status === "live" ? (
              latestBid !== undefined ? (
                <div className="bg-linear-purple py-2 px-4 text-sm flex items-center font-semibold gap-4 text-brand-textBlack">
                  <SimpleHammerIcon />
                  Bidders are placing their bids
                </div>
              ) : (
                <div className="bg-linear-purple py-2 px-4 text-sm flex items-center font-semibold gap-4 text-brand-textBlack">
                  <SimpleHammerIcon />
                  No one has placed the bids yet
                </div>
              )
            ) : (
              <></>
            )}

            <BidHistorySection
              app="banker"
              bidsEvent={correctBids}
              wrongBidsEvent={wrongBids}
              setShowBidHistoryModel={setShowBidHistoryModel}
              isSwissAuction={false}
            />
            <div className="flex justify-between gap-3 pt-5">
              {status !== "end" && status !== "cancelled" && (
                <>
                  <Input
                    className="w-3/4 border border-gray-400"
                    type="text"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    placeholder="Send message to bidders"
                  />
                  <Button className="w-1/4" onClick={handleAnnouncement}>
                    Send
                  </Button>
                </>
              )}
            </div>
          </div>
          <BidHistoryModel
            app="banker"
            bidsEvent={correctBids}
            wrongBidsEvent={wrongBids}
            open={showBidHistoryModel}
            setOpen={setShowBidHistoryModel}
            isSwissAuction={false}
          />
        </div>

        <div className="w-full mx-auto bg-brand-lightOrange lg:w-1/4 border border-gray-200">
          <EventContentData
            data={data}
            biddingType={data?.bidding_type}
            latestBidAmount={latestBidAmount}
            currentUserLatestBid={latestBid}
            latestBid={latestBid}
            status={status}
            endTime={endTime}
            showModal={openModal}
            setShowModal={setOpenModal}
            app="banker"
          />
          <PropertyContentData
            bank={data?.property_dump?.bank?.name}
            state={data?.property_dump?.state?.name}
            city={data?.property_dump?.city?.name}
          />
        </div>
      </div>
      {announcementSuccess && <AnnouncementSuccessModal />}
    </>
  );
}
